import { render } from "./CobrosView.vue?vue&type=template&id=e3d07da8&scoped=true"
import script from "./CobrosView.vue?vue&type=script&lang=js"
export * from "./CobrosView.vue?vue&type=script&lang=js"

import "./CobrosView.vue?vue&type=style&index=0&id=e3d07da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d07da8"]])

export default __exports__